/* SIGNORA — necklace & pendant length guide ("Where your chain sits").
   TWO MODES:
   · fixed     — fixed/optional-chain products: honest arrival preview. The piece's own
     length is DETECTED per product (never assumed): 1) a "Chain" option value
     (pendants: "With 18″ Chain" in any spelling), 2) the description's spec text
     ("Length Approx. 16 in"). If no length is found, no guide is shown.
   · chooser  — necklace products with REAL length variants (16/18/20/22): every
     length selectable, USE picks the matching variant pill in the buy box.
   The section injects window.SJWCNG_DATA = {t, chain, hasLengthVariants}.
   Exposed as window.SJWCNG {open, openChooser} — the section routes necklace
   "Find my size" clicks here instead of the wrist calculator. */
(function () {
  'use strict';
  var SIT = {
    14: { n: 'Choker', sit: 'at the neck' },
    16: { n: 'Collar', sit: 'at the collarbone' },
    18: { n: 'Princess', sit: 'below the collarbone' },
    20: { n: 'Matinée', sit: 'above the bust' },
    22: { n: 'Opera', sit: 'at the bust' },
    24: { n: 'Opera', sit: 'at the bust' }
  };
  function yOf(v) { return 150 + (v - 14) * 18.5; }
  function fitP(k) {
    if (OWN == null) {
      return {
        crew: 'With a <b>crew neck</b>, shorter lengths sit above the fabric and stay visible.',
        v: 'With a <b>V-neck</b>, an 18″ classic lands right in the V.',
        open: 'With an <b>open neckline</b>, longer drops dress the collarbone beautifully.'
      }[k];
    }
    var o = OWN + '″', sit = nameFor(OWN).sit, poss = (SRC === 'option') ? 'the ' + o + ' chain' : 'your ' + o;
    return {
      crew: 'With a <b>crew neck</b>, ' + poss + ' sits ' + sit + ' — wear the piece outside the collar so it stays visible.',
      v: 'With a <b>V-neck</b>, ' + poss + ' sits ' + sit + (OWN === 18 ? ' — it lands right in the V.' : '.'),
      open: 'With an <b>open neckline</b>, ' + poss + ' dresses the neckline; a longer drop is an atelier request away.'
    }[k];
  }
  var FIT_C = {
    crew: { best: 16, txt: 'With a <b>crew neck</b>, shorter lengths sit above the fabric — <b>16″</b> keeps the piece visible.' },
    v: { best: 18, txt: 'With a <b>V-neck</b>, the chain should echo the neckline — <b>18″</b> lands right in the V.' },
    open: { best: 20, txt: 'With an <b>open neckline</b>, longer drops dress the décolletage — <b>20″</b> flatters most.' }
  };
  var OWN = null, SRC = null, NOUN = 'pendant', OPTCH = '', mode = 'fixed', LENS = [], view = null, fit = 'v', ov = null, lastFocus = null, lenrowRef = null;

  function nameFor(v) {
    if (SIT[v]) return SIT[v];
    var keys = [14, 16, 18, 20, 22, 24], best = keys[0];
    keys.forEach(function (k) { if (Math.abs(k - v) < Math.abs(best - v)) best = k; });
    return SIT[best];
  }
  function inchVal(s) {
    var m = /(\d{2}(?:\.\d+)?)\s*(?:-|–|\s)*(?:inch(?:es)?\b|in\b|["′″”])/i.exec(String(s || ''));
    if (!m) return null;
    var v = parseFloat(m[1]);
    return (v >= 12 && v <= 26) ? v : null;
  }
  function descLen(t) {
    t = (t || '').replace(/\s+/g, ' ');
    var pats = [
      /(?:chain |necklace )?length[^a-z0-9]{0,8}approx\.?[^0-9]{0,10}(\d{2}(?:\.\d+)?)\s*(?:inch(?:es)?\b|in\b|["″”])/i,
      /with\s+(?:a\s+)?(?:matching\s+)?(\d{2})\s*(?:-|\s)*(?:inch(?:es)?\b|in\b|["″”])?\s*chain/i,
      /chain[^.?!]{0,40}?(\d{2})\s*(?:inch(?:es)?\b|in\b|["″”])/i,
      /length[^0-9?]{0,30}?(\d{2}(?:\.\d+)?)\s*(?:inch(?:es)?\b|in\b|["″”])/i
    ];
    for (var i = 0; i < pats.length; i++) {
      var m = pats[i].exec(t);
      if (!m) continue;
      /* never trust "choose 16 in…" marketing copy — only spec-style statements */
      var pre = t.slice(Math.max(0, m.index - 24), m.index + m[0].length);
      if (i > 0 && /choose|select|\?/i.test(pre)) continue;
      var v = parseFloat(m[1]);
      if (v >= 12 && v <= 26) return v;
    }
    return null;
  }
  var DETD = false;
  /* textContent fuses adjacent nodes ("…16 incustom sizing…") which breaks the
     unit word-boundary — join every text node with a space instead */
  function textOf(el) {
    var out = [];
    (function walk(n) {
      if (n.nodeType === 3) { out.push(n.nodeValue); return; }
      if (n.nodeType !== 1 || /^(SCRIPT|STYLE)$/.test(n.tagName)) return;
      for (var i = 0; i < n.childNodes.length; i++) walk(n.childNodes[i]);
    })(el);
    return out.join(' ');
  }
  function detect() {
    if (DETD) return; DETD = true;
    var D = window.SJWCNG_DATA || {};
    var t = String(D.t || '').toLowerCase();
    OWN = null; SRC = null; OPTCH = '';
    NOUN = /pendant/.test(t) ? 'pendant' : 'necklace';
    var ov2 = inchVal(D.chain);
    if (ov2 != null) { OWN = ov2; SRC = 'option'; OPTCH = String(D.chain); NOUN = 'pendant'; return; }
    var d = document.querySelector('.sjwpp-desc');
    var dv = d ? descLen(textOf(d)) : null;
    if (dv != null) { OWN = dv; SRC = 'desc'; }
  }

  function lensFor(values) {
    return values.map(function (v) {
      var m = nameFor(v);
      return { v: v, n: m.n, sit: m.sit, y: yOf(v) };
    });
  }
  function pillLens(lenrow) {
    return [].map.call(lenrow.querySelectorAll('.sjwpp-lenpill .lv'), function (x) { return parseFloat(x.textContent); })
      .filter(function (x) { return !isNaN(x); })
      .sort(function (a, b) { return a - b; });
  }
  function currentPill(lenrow) {
    var on = lenrow.querySelector('.sjwpp-lenpill.on .lv');
    return on ? parseFloat(on.textContent) : null;
  }
  function nearest(target) {
    var best = LENS[0].v;
    LENS.forEach(function (L) { if (Math.abs(L.v - target) < Math.abs(best - target)) best = L.v; });
    return best;
  }

  function ready(fn) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  ready(function () {
    var root = document.querySelector('.sjwpp-main2'); if (!root) return;
    if (root.querySelector('.sjwpp-lencard, .sjwpp-lenrow')) return; /* chooser products: the card's own Find-my-size routes here via the section */
    detect();
    if (OWN == null) return; /* fixed products only get a guide when their actual length is stated */
    var anchor = null;
    [].forEach.call(root.querySelectorAll('.sjwpp-l'), function (l) {
      if (anchor) return;
      if (l.offsetParent === null) return;
      if (/include|chain|length/i.test(l.textContent || '')) anchor = l;
    });
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sjw-cng-btn';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.5"/></svg>See where ' + OWN + '&Prime; sits';
    btn.addEventListener('click', open);
    if (anchor) { anchor.appendChild(btn); }
    else {
      var sum = root.querySelector('.sjwpp-summary');
      if (!sum) return;
      var holder = document.createElement('div');
      holder.style.cssText = 'display:flex;justify-content:flex-end;margin:0 0 10px';
      holder.appendChild(btn);
      sum.parentNode.insertBefore(holder, sum);
    }
  });

  function build() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'sjw-cng-ov';
    ov.innerHTML =
      '<div class="sjw-cng" role="dialog" aria-modal="true" aria-label="Chain length guide">' +
      '<div class="sjw-cng-eye">Signora · Atelier</div>' +
      '<h3 class="sjw-cng-title" data-cng-title>Where your chain sits</h3>' +
      '<button type="button" class="sjw-cng-x" aria-label="Close">&#x2715;</button>' +
      '<div class="sjw-cng-rule"></div>' +
      '<div class="sjw-cng-cols">' +
        '<div class="sjw-cng-sil"><svg viewBox="0 0 340 360" aria-label="Where each length sits">' +
          '<path d="M120 8 C120 52 108 74 84 92 C130 104 150 118 170 118 C190 118 210 104 256 92 C232 74 220 52 220 8" fill="none" stroke="#21382F" stroke-width="1.6" stroke-linecap="round"/>' +
          '<path d="M84 92 C56 104 28 122 10 150 M256 92 C284 104 312 122 330 150" fill="none" stroke="#21382F" stroke-width="1.6" stroke-linecap="round"/>' +
          '<g data-cng-arcs></g></svg>' +
          '<div class="sjw-cng-silcap">Shown in proportion · sits as worn</div></div>' +
        '<div>' +
          '<p class="sjw-cng-lbl"><b>01</b> <span data-cng-l1>Your chain</span></p>' +
          '<div class="sjw-cng-lens" data-cng-lens></div>' +
          '<p class="sjw-cng-note" data-cng-note></p>' +
          '<p class="sjw-cng-lbl" style="margin-top:16px"><b>02</b> Worn with</p>' +
          '<div class="sjw-cng-seg" data-cng-seg>' +
            '<button type="button" data-k="crew">Crew neck</button>' +
            '<button type="button" data-k="v" class="on">V-neck</button>' +
            '<button type="button" data-k="open">Open neckline</button></div>' +
          '<p class="sjw-cng-note" data-cng-hint></p>' +
          '<div class="sjw-cng-plate"><div class="sjw-cng-platein">' +
            '<div class="sjw-cng-peye" data-cng-peye>Included with your pendant</div>' +
            '<div class="sjw-cng-prow"><span class="sjw-cng-pval" data-cng-pval>18&Prime;<small>Princess</small></span>' +
            '<button type="button" class="sjw-cng-ok" data-cng-ok>Perfect &mdash; continue</button></div>' +
            '<div class="sjw-cng-pwhy" data-cng-pwhy></div>' +
          '</div></div>' +
          '<p class="sjw-cng-foot" data-cng-foot></p>' +
        '</div>' +
      '</div></div>';
    document.body.appendChild(ov);
    ov.querySelector('.sjw-cng-x').addEventListener('click', close);
    ov.querySelector('[data-cng-ok]').addEventListener('click', function () {
      if (mode === 'choose' && lenrowRef) {
        var hit = null;
        [].forEach.call(lenrowRef.querySelectorAll('.sjwpp-lenpill'), function (p) {
          var lv = p.querySelector('.lv');
          if (lv && Math.abs(parseFloat(lv.textContent) - view) < 0.01) hit = p;
        });
        if (hit) hit.click();
      }
      close();
    });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.querySelector('[data-cng-seg]').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      fit = b.getAttribute('data-k');
      if (mode === 'choose') view = nearest(FIT_C[fit].best);
      render();
    });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'Tab') {
        var f = ov.querySelectorAll('button,a'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function svgEl(tag, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }
  function render() {
    var choose = (mode === 'choose');
    var approx = (!choose && SRC === 'desc') ? 'approx. ' : '';
    var title = choose ? 'Find your necklace length' : ('How your ' + approx + OWN + '″ ' + NOUN + ' will sit');
    ov.querySelector('[data-cng-title]').textContent = title;
    ov.querySelector('.sjw-cng').setAttribute('aria-label', title);
    ov.querySelector('[data-cng-l1]').textContent = choose ? 'Your length' : ('Your ' + NOUN);
    var g = ov.querySelector('[data-cng-arcs]'); g.innerHTML = '';
    LENS.forEach(function (L) {
      var hot = choose ? (L.v === view) : (L.v === OWN);
      var act = (!choose && L.v === view && view !== OWN);
      var w = 105 + (L.y - 150) * 0.52;
      var p = svgEl('path', {
        d: 'M' + (170 - w) + ' ' + (L.y - 26) + ' Q170 ' + (L.y + 22) + ' ' + (170 + w) + ' ' + (L.y - 26),
        fill: 'none', 'stroke-linecap': 'round',
        stroke: hot ? '#2C4A41' : (act ? '#7E6535' : '#C2A878'),
        'stroke-width': hot ? 2.2 : (act ? 1.6 : 1.1)
      });
      if (!hot) p.setAttribute('stroke-dasharray', act ? '3 4' : '1 5');
      p.style.cursor = choose ? 'pointer' : 'default';
      if (choose) p.addEventListener('click', function () { view = L.v; render(); });
      g.appendChild(p);
      if (hot) {
        g.appendChild(svgEl('circle', { cx: 170, cy: L.y + 9, r: 5, fill: '#fff', stroke: '#2C4A41', 'stroke-width': 1.6 }));
        g.appendChild(svgEl('circle', { cx: 170, cy: L.y + 9, r: 2, fill: '#C2A878' }));
      }
      var t = svgEl('text', { x: 170 + w + 8, y: L.y - 22, 'font-size': 10.5, fill: hot ? '#21382F' : '#A79A87', 'font-weight': hot ? 600 : 400 });
      t.textContent = L.v + '″' + (!choose && L.v === OWN ? ' · yours' : '');
      t.style.cursor = choose ? 'pointer' : 'default';
      if (choose) t.addEventListener('click', function () { view = L.v; render(); });
      g.appendChild(t);
    });
    var lens = ov.querySelector('[data-cng-lens]'); lens.innerHTML = '';
    lens.style.gridTemplateColumns = 'repeat(' + Math.min(LENS.length, 5) + ',1fr)';
    LENS.forEach(function (L) {
      var hot = choose ? (L.v === view) : (OWN != null && L.v === OWN);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sjw-cng-len' + (hot ? ' own' : '') + (L.v === view && !hot ? ' view' : '');
      b.title = choose ? 'Select ' + L.v + '″' : ('Your ' + NOUN + ' length');
      b.innerHTML = '<span class="v">' + L.v + '″</span><span class="n">' + L.n + '</span>';
      if (choose) b.addEventListener('click', function () { view = L.v; render(); });
      else { b.setAttribute('aria-current', 'true'); b.style.cursor = 'default'; }
      lens.appendChild(b);
    });
    var L = LENS.filter(function (x) { return x.v === view; })[0] || LENS[0];
    var note = ov.querySelector('[data-cng-note]');
    var oN = OWN != null ? nameFor(OWN) : null;
    if (choose) {
      note.innerHTML = '<b>' + L.v + '″ · ' + L.n + '</b> sits ' + L.sit + '.' + (L.v === FIT_C[fit].best ? ' Our pick for your neckline.' : '');
    } else {
      note.innerHTML = (SRC === 'option')
        ? '<b>' + OWN + '″ · ' + oN.n + '</b> sits ' + oN.sit + '. This is the chain offered with your ' + NOUN + '.'
        : '<b>Approx. ' + OWN + '″ · ' + oN.n + '</b> sits ' + oN.sit + '. This is how your necklace will arrive.';
    }
    ov.querySelector('[data-cng-hint]').innerHTML = choose ? FIT_C[fit].txt : fitP(fit);
    ov.querySelector('[data-cng-peye]').textContent = choose ? 'Your length' : 'As crafted';
    ov.querySelector('[data-cng-pval]').innerHTML = choose ? (L.v + '&Prime;<small>' + L.n + '</small>')
      : (approx + OWN + '&Prime;<small>' + nameFor(OWN).n + '</small>');
    ov.querySelector('[data-cng-ok]').innerHTML = choose ? ('Use ' + L.v + '&Prime;') : 'Got it';
    ov.querySelector('[data-cng-pwhy]').textContent = choose
      ? ('Sits ' + L.sit + ' — made to your order in our Surat atelier.')
      : (SRC === 'option'
        ? ('The offered ' + OWN + '″ chain sits ' + oN.sit + ' and arrives ready to wear.')
        : ('Your ' + NOUN + ' is crafted at approximately ' + OWN + '″ and arrives ready to wear.'));
    ov.querySelector('[data-cng-foot]').innerHTML = choose
      ? 'Between lengths? Size up &mdash; and measure at day&rsquo;s end.'
      : 'Need another length? <a href="/pages/contact">Request custom sizing</a> from our Surat atelier.';
    [].forEach.call(ov.querySelectorAll('[data-cng-seg] button'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-k') === fit);
    });
  }

  function ownEye() {
    if (OWN == null) return NOUN === 'pendant' ? 'Pairs with your chain' : 'Made to order';
    return (SRC === 'option') ? ('Offered with your ' + NOUN) : ('Your ' + NOUN + ' length');
  }
  function openCommon() {
    build();
    render();
    lastFocus = document.activeElement;
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
    ov.querySelector('.sjw-cng-x').focus();
  }
  function open() {
    detect();
    if (OWN == null) return;
    mode = 'fixed'; lenrowRef = null;
    LENS = lensFor([OWN]);
    view = OWN; fit = 'v';
    openCommon();
  }
  function openChooser(lenrow) {
    mode = 'choose'; lenrowRef = lenrow;
    var vals = pillLens(lenrow);
    if (!vals.length) { open(); return; }
    LENS = lensFor(vals);
    var cur = currentPill(lenrow);
    fit = 'v';
    view = (cur != null && vals.indexOf(cur) > -1) ? cur : nearest(FIT_C[fit].best);
    openCommon();
  }
  function close() {
    ov.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  window.SJWCNG = { open: open, openChooser: openChooser };
})();
